import { useQuery, useMutation } from 'react-query';
import { getFilterOptions, getEInvoiceList, getDocumentsByInvestor, downloadEInvoicePdf } from './eInvoiceApis';

export enum EInvoiceQueryKeys {
  GET_FILTER_OPTIONS = 'getEInvoiceFilterOptions',
  GET_E_INVOICE_LIST = 'getEInvoiceList',
  GET_DOCUMENTS_BY_INVESTOR = 'getDocumentsByInvestor',
  DOWNLOAD_EINVOICE_PDF = 'downloadEInvoicePdf',
}

export const useEInvoiceFilterOptions = () => {
  return useQuery(
    EInvoiceQueryKeys.GET_FILTER_OPTIONS,
    async () => (await getFilterOptions()).data,
  );
};

export const useEInvoice = (search?: string) => {
  return useQuery(
    [EInvoiceQueryKeys.GET_E_INVOICE_LIST, search],
    async () => (await getEInvoiceList(search ? { search } : undefined)).data,
    {
      select: (d) => ({
        data: d?.investors || [],
        total: d?.investors?.length || 0,
      }),
    },
  );
};

export const useDocumentsByInvestor = (investorName: string, tableFilterData: any) => {
  const fetchList = () => {
    const payload: any = {
      ...tableFilterData,
    };

    if (tableFilterData.e_invoice_number) {
      payload.search = {
        value: tableFilterData.e_invoice_number,
      };
    }

    return getDocumentsByInvestor(investorName, payload);
  };

  return useQuery(
    [EInvoiceQueryKeys.GET_DOCUMENTS_BY_INVESTOR, investorName, tableFilterData],
    fetchList,
    {
      select: (d) => ({
        data: d.data?.data || [],
        totalFiltered: d.data?.totalFiltered || d.data?.data?.length || 0,
      }),
      keepPreviousData: true,
      staleTime: 5000,
      enabled: !!investorName,
    },
  );
};

export const useDownloadEInvoicePdf = () => {
  return useMutation(
    'downloadEInvoicePdf',
    (id: number) => downloadEInvoicePdf(id),
  );
};

export const useEInvoicePdf = (id: number | null) => {
  return useQuery(
    [EInvoiceQueryKeys.DOWNLOAD_EINVOICE_PDF, id],
    async () => (await downloadEInvoicePdf(id!)).data,
    {
      enabled: false,
      staleTime: Infinity,
    },
  );
};
